export default __webpack_public_path__ + "static/media/digital_wireframe_2.299638d3.jpg";